import React from 'react';
import {
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
} from '@stripe/react-stripe-js';
import { CheckoutPayment } from '../../../enums';
import { ToastMolecule } from '../toast';
import { useStripeCheckoutCardPaymentEffect } from './stripe-checkout-card-payment.effect';

export const StripeCheckoutCardPaymentMolecule = () => {
  const cardStyle = {
    style: {
      base: {
        color: '#0032a0',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#0032a0',
        },
      },
      invalid: {
        color: '#fe5000',
        iconColor: '#fe5000',
      },
    },
  };
  const optionsCardNum = {
    ...cardStyle,
    placeholder: CheckoutPayment.CARD_NUM_LABEL,
    showIcon: true,
  };

  const { members, processing, disabled, success, error, onChange, onSubmit } =
    useStripeCheckoutCardPaymentEffect();

  return (
    <section className="mt-3 w-full lg:w-11/12">
      {error && (
        <div className="text-waldo-tangerine text-sm font-medium mb-5">
          <ToastMolecule
            toastList={[
              {
                id: 1,
                title: CheckoutPayment.PAYMENT_FAILED,
                description: error,
                bgColor: 'bg-waldo-poppy',
                icon: 'info',
              },
            ]}
            position="Top-Left"
            autoDelete={true}
            autoDeleteTime={8000}
          />
        </div>
      )}
      <form id="payment-form" onSubmit={onSubmit}>
        <div className="relative">
          <input
            className={`my-0.5 placeholder-waldo-blue ${
              !members.cardHolderName.isClean && !members.cardHolderName.isValid
                ? 'input-error-border'
                : ''
            }`}
            type="input"
            placeholder={CheckoutPayment.CARD_NAME_LABEL}
            onChange={(e) => members.cardHolderName.onChange(e.target.value)}
            onFocus={() => members.cardHolderName.onFocus()}
            onBlur={() => members.cardHolderName.onBlur()}
          />
          {!members.cardHolderName.isClean &&
            !members.cardHolderName.isValid && (
              <div className="absolute top-2 right-4 text-sm text-waldo-poppy">
                {members.cardHolderName.errors[0]}
              </div>
            )}
        </div>

        <div data-cy="cardnumber" className="w-full">
          <CardNumberElement options={optionsCardNum} onChange={onChange} />
        </div>
        <div className="w-full flex flex-col lg:flex-row justify-between">
          <div data-cy="exp-date" className="w-full lg:w-1/2">
            <CardExpiryElement options={cardStyle} onChange={onChange} />
          </div>
          <div data-cy="cvc" className="w-full ml-0 lg:ml-5 lg:w-1/2">
            <CardCvcElement options={cardStyle} onChange={onChange} />
          </div>
        </div>
        <div className="flex flex-col w-full mt-5">
          <button
            disabled={processing || disabled || success}
            id="submit"
            className="button btn-cta w-full lg:w-2/5 mb-10"
          >
            <span id="button-text">
              {processing
                ? CheckoutPayment.CARD_PROCESSING
                : CheckoutPayment.CARD_SUCCESSFUL}
            </span>
          </button>
        </div>
      </form>
    </section>
  );
};
